import { preview } from '@/components/form/preview'

import { useTexts } from '../useTexts'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function Type(props: Props) {
  const { extOrder } = props

  const texts = useTexts()

  return (
    <preview.Field label={texts.type.label}>
      {texts.type.value(extOrder.orderStepType)}
    </preview.Field>
  )
}
